export const LOGO = "/logo-mark.png";

export function Logo({ className = "", imgClassName = "", showText = false }) {
  return (
    <span className={`inline-flex items-center gap-3 ${className}`}>
      <img src={LOGO} alt="Drunk Fruit Mobile Bar" className={imgClassName || "h-10 w-auto"} draggable={false} />
      {showText && (
        <span className="font-serif text-xl tracking-tight leading-none">
          Drunk Fruit<span className="block text-[10px] uppercase tracking-[0.3em] text-muted-foreground">Mobile Bar</span>
        </span>
      )}
    </span>
  );
}

export default Logo;
